export const toAbsoluteUrl = (pathname: string) => {
  // In Vite, assets in public folder are served from root
  return pathname.startsWith('/') ? pathname : `/${pathname}`
}
